import { getAddressFromBraintreePayload } from './getAddressFromBraintreePayload';
import { getAddressFromEditableMop } from './getAddressFromEditableMop';
export var getAddressInfo = function getAddressInfo(defaultCountry, editableMop, thirdPartyBraintreePayload) {
  var address;
  if (thirdPartyBraintreePayload) {
    address = getAddressFromBraintreePayload(defaultCountry, thirdPartyBraintreePayload);
  } else {
    address = getAddressFromEditableMop(editableMop);
  }
  return address;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/getAddressInfo.js
// module id = 4557
// module chunks = 11